import { createGuideStore } from "views/components/Guide";

export const useLpSeedGuideStore = createGuideStore("lp-seed-v1");
export const useLpReviewGuideStore = createGuideStore("lp-review-v1");
